/**
 * Snapshot-branding helper.
 *
 * Every saved document carries the hotel branding (always) and the
 * restaurant branding (only when the doc was authored inside a
 * restaurant). The branding lives inside `payload.branding` and is read
 * back by `SnapshotViewerDialog` to render a branded header + by the
 * print path to render a branded export.
 *
 * `outlet` may be null when the document is authored from a department
 * workspace; the hotel branding alone is enough in that case.
 */
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cached = null;
let cachedAt = 0;
const TTL_MS = 60_000;

async function getProperty() {
  const now = Date.now();
  if (cached && now - cachedAt < TTL_MS) return cached;
  try {
    const { data } = await axios.get(`${API}/property`);
    cached = data; cachedAt = now;
    return data;
  } catch (_e) {
    return cached || null;
  }
}

/** Build a flat branding object suitable for storage in `payload.branding`. */
export async function buildSnapshotBranding(outlet) {
  const prop = await getProperty();
  return {
    hotel_name: prop?.title || 'Dreams Rose Hall Resort & Spa',
    hotel_subtitle: prop?.subtitle || '',
    hotel_logo_url: prop?.brand_logo_url || '',
    hotel_operator_logo_url: prop?.operator_logo_url || '',
    hotel_ownership_logo_url: prop?.ownership_logo_url || '',
    restaurant_name: outlet?.name || '',
    restaurant_logo_url: outlet?.logo_url || '',
    restaurant_accent: outlet?.accent_color || '',
  };
}

/** Resolve a backend-relative logo URL to a fully qualified URL the
 *  viewer / print iframe can fetch. External URLs are returned as-is. */
export function absLogo(url) {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  return `${process.env.REACT_APP_BACKEND_URL}${url}`;
}
